import { useEffect, useState } from "react";
import AdminAPIPage from "../../api/adminAPIs";
import useDisplaySnackbar from "../../utils/useDisplaySnackbar";
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";

interface TranscriptViewProps {
    meetingId: string
  }
  const TranscriptView: React.FC<TranscriptViewProps> = ({ meetingId }) => {
    const { showSnackbar } = useDisplaySnackbar();
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const [transcript, setTranscript] = useState<string | null>(null);
    const [openDialog, setOpenDialog] = useState(false);
    const enabled = !!meetingId;
    const {
        isLoading: isDataLoading,
        isFetching: isDataFetching,
        isSuccess,
        isError,
        error,
        data: meetingsData,
      } = AdminAPIPage.useGetMeetingTranscriptReanalysis(
        {
          meeting_id: meetingId,
          collateral_type: "transcript",
        },
        enabled
      );
      useEffect(() => {
        setShowSpinner(isDataLoading || isDataFetching);
        if (isSuccess) {
          const meetingtranscript = meetingsData?.data?.data?.transcript;
          setTranscript(meetingtranscript || "No transcript available");
          setOpenDialog(true); 
        }
        if (isError) {
          showSnackbar("error", error);
        }
      }, [isDataLoading, isDataFetching, isSuccess, isError, meetingsData]);
      const handleCloseDialog = () => {
        setOpenDialog(false);
        setTranscript(null);
      };
    
      return (
        <div>
          <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
            <DialogTitle 
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}>
                <span>Transcript</span>
              
            <IconButton onClick={handleCloseDialog} size="small">
          <Button onClick={handleCloseDialog}>Close</Button>
          </IconButton>
          </DialogTitle>
            <DialogContent>
              {showSpinner ? (
                <div>Loading...</div>
              ) : (
                <pre className="whitespace-pre-wrap break-words p-4 bg-gray-100 rounded">
                  {transcript}
                </pre>
              )}
            </DialogContent>
          </Dialog>
        </div>
      );
    };
    
    export default TranscriptView;